// El marco de las pantallas del Catálogo en el teléfono (ADR-2026-10-15-el-catalogo-en-el-telefono-2):
// como Ambiente completo, la pantalla del modo ocupa el viewport (`fixed inset-0`, blanca) debajo
// del chrome flotante del shell (el botón de atrás vive arriba, en 3.5rem más el área segura). En
// el flujo de la página, la franja de arriba quedaba del gris del shell y la grilla crecía con el
// documento: la barra de "Siguiente" terminaba al final de todos los productos.
import type { CSSProperties } from 'react';

export const MARCO_TELEFONO = 'max-md:fixed max-md:inset-0 max-md:z-30 max-md:h-auto max-md:bg-white';

/** El aire de arriba para el chrome del shell; en el escritorio, nada. */
export const estiloDelMarcoTelefono = (esTelefono: boolean): CSSProperties | undefined =>
  esTelefono ? { paddingTop: 'calc(env(safe-area-inset-top, 0px) + 3.5rem)' } : undefined;
